import _ from 'underscore';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const Switch = ({
	name,
	title,
	checked,
	onChange,
	theme,
	special,
	tabIndex,
	ariaLabel,
	onKeyDown,
	className
}) => {
	const [localChecked, setLocalChecked] = useState(checked);
	const handleChange = (event) => {
		setLocalChecked(event.target.checked);

		setTimeout(() => {
			onChange(name, event.target.checked);
		}, 100);
	};

	const handleKeyDown = (event) => {
		onKeyDown(event);

		if (event.key === 'Enter') {
			const input = event.target.querySelector('input') || event.target;

			input.click();
		}
	};

	useEffect(() => {
		setLocalChecked(checked);
	}, [checked]);

	return (
		// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
		<label
			className={cx(
				styles.Switch,
				styles[`Switch_theme_${theme}`],
				styles[`Switch_special_${special}`],
				className,
				localChecked && styles.Switch_checked
			)}
			htmlFor={name}
			onKeyDown={handleKeyDown}
			aria-label={ariaLabel || title}
		>
			<input
				type="checkbox"
				checked={localChecked}
				onChange={handleChange}
				className={styles.Switch__Input}
				id={name}
				tabIndex={tabIndex}
			/>
			<span className={styles.Switch__Icon} />
			<span className={styles.Switch__Title}>{title}</span>
		</label>
	);
};

Switch.propTypes = {
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	title: PropTypes.string,
	checked: PropTypes.bool,
	theme: PropTypes.oneOf(['button', 'simple']),
	special: PropTypes.oneOf(['pushkinCard']),
	tabIndex: PropTypes.string,
	ariaLabel: PropTypes.string,
	onKeyDown: PropTypes.func,
	className: PropTypes.string
};

Switch.defaultProps = {
	checked: false,
	tabIndex: '0',
	onKeyDown: _.noop
};

export default Switch;
